import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { List, ListItem, styled, Typography } from '@mui/material';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: 'list-item',
  paddingLeft: '.25rem',
}));

const SecondaryInfo = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  fontSize: '.85em',
  paddingTop: '.25rem',
}));

const StoryousDialogContent: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <List sx={{ listStyle: 'decimal', pl: 2.5 }}>
        <StyledListItem>
          <Typography component='p'>
            {t('connections-dialog-storyous-1-primary')}
          </Typography>
          <SecondaryInfo>
            <Trans
              i18nKey='connections-dialog-storyous-1-secondary'
              components={[<strong></strong>]}
            />
          </SecondaryInfo>
        </StyledListItem>
        <StyledListItem>
          <Typography component='p'>
            {t('connections-dialog-storyous-2-primary')}
          </Typography>
          <SecondaryInfo>
            <Trans
              i18nKey='connections-dialog-storyous-2-secondary'
              components={[<strong></strong>]}
            />
          </SecondaryInfo>
        </StyledListItem>
        <StyledListItem>
          <Typography component='p'>
            {t('connections-dialog-storyous-3-primary')}
          </Typography>
          <SecondaryInfo>
            <Trans
              i18nKey='connections-dialog-storyous-3-secondary'
              components={[<strong></strong>]}
            />
          </SecondaryInfo>
        </StyledListItem>
      </List>
    </>
  );
};

export default StoryousDialogContent;
